if (!customElements.get('dut-guide-picker')) {
  customElements.define('dut-guide-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[data-guide-panel]')];
      if (!this.tabs.length || this.tabs.length !== this.panels.length) return;
      this.dataset.ready = 'true';
      this.querySelector('[role="tablist"]').hidden = false;
      this.tabs.forEach((tab, index) => {
        this.panels[index].setAttribute('role', 'tabpanel');
        this.panels[index].setAttribute('aria-labelledby', tab.id);
        tab.addEventListener('click', () => this.select(index));
        tab.addEventListener('keydown', event => {
          let next = index;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index + this.tabs.length - 1) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else return;
          event.preventDefault(); this.select(next); this.tabs[next].focus();
        });
      });
      this.select(0);
    }
    select(index) {
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        this.panels[i].hidden = i !== index;
      });
    }
  });
}
